export const timeSeriesOfPatentForTrends = {
    copy: 'コピー',
    chartTitle: '世界の直近の特許出願数推移',
    chartDescription:
        '特許出願数が大きいテーマ上位10件を表示しています。\nテーマが絞り込まれている場合は、絞り込み結果の中で上位10テーマを表示します。',
    themeName: 'テーマ名',
    xAxis: '年',
    yAxis: '特許出願数'
}
